import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Passcode = function Passcode(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 12h.005M17 12h.005M7 12h.005M5.2 7h13.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C22 8.5198 22 9.08 22 10.2v3.6c0 1.1201 0 1.6802-.218 2.108a2 2 0 0 1-.874.874C20.4802 17 19.9201 17 18.8 17H5.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C2 15.4802 2 14.9201 2 13.8v-3.6c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C3.5198 7 4.08 7 5.2 7m7.05 5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
    })
  }));
};
export default Passcode;